import React from "react";
import Layout from "../Layout";
import HeaderEmails from "./HeaderEmails";
import ListEmails from "./ListEmails";
import AddOrgEmail from "../shared/AddOrgEmail";

const Emails = () => {

  return (
    <Layout>
      <HeaderEmails />
      <ListEmails />
      <AddOrgEmail />
    </Layout>
  );
};

export default Emails;
